import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { getOtherOptionsFromWindow } from "../utils";
import { useCallback } from "react";

function useWebsiteBannerOverlay() {
  var _getOtherOptionsFromW = getOtherOptionsFromWindow(),
      pageRequestUuid4 = _getOtherOptionsFromW.pageRequestUuid4;

  var overlay = document.getElementById(pageRequestUuid4);
  var toggleOverlay = useCallback(function (_ref, show) {
    var _ref$layout = _ref.layout,
        animationIn = _ref$layout.animationIn,
        animationInDuration = _ref$layout.animationInDuration,
        animationOut = _ref$layout.animationOut,
        animationOutDuration = _ref$layout.animationOutDuration;
    var defaultIfNoAnimation = 100; // Avoid "hard" overlay

    var useDuration = show ? animationIn === "none" ? defaultIfNoAnimation : animationInDuration : animationOut === "none" ? defaultIfNoAnimation : animationOutDuration; // Toggle SSR-rendered overlay

    useDuration > 0 && (overlay.style.transition = "background ".concat(useDuration, "ms"));
    overlay.style.background = "transparent";

    if (show) {
      // We need a small delay to avoid flickering of animation out effect in customizer
      setTimeout(function () {
        overlay.style.display = "block";
      }, 0);
      setTimeout(function () {
        var bg = overlay.getAttribute("data-bg");
        overlay.style.background = bg ? bg.split(":")[1].trim().replace(";", "") : "transparent";
      }, 100);
    } else {
      setTimeout(function () {
        overlay.style.display = "none";
      }, useDuration);
    }

    var animationVisible = {
      animationVisible: show
    };
    return show ? _objectSpread({
      visible: true
    }, animationVisible) : animationVisible;
  }, []);
  return {
    overlay: overlay,
    toggleOverlay: toggleOverlay
  };
}

export { useWebsiteBannerOverlay };